<template>
  <div class="ds-control dsf_teas_class_album_details mobile" :class="{ 'ds-no-padding': !isDesign }">
    <div class="album_nav">
      <div class="nav_left">
        <div v-if="isShowCheck" class="nav_left_qx" @click="isShowCheck=false">取消</div>
        <div v-else class="icon_back" @click="goBack">
          <i class="iconfont icon-icon-back"></i>
          返回
        </div>
      </div>
      <div class="nav_content">{{chooseArr.length && isShowCheck?'已选择（'+chooseArr.length+'张)':'相册详情'}}</div>
      <div class="nav_btn" v-if="isShowCheck" @click="selectAll">全选</div>
      <div class="nav_btn" v-else @click="chooseAlbumList">选择</div>
    </div>
    <van-image class="album_cover_img" width="100%" height="110px" fit="cover" :src="queryString.coverPhoto | imgFormat">
      <template v-slot:error>
        <img :src="require('../../assets/styles/themes/img/photoAlbum2.png')" alt="" class="err_img">
      </template>
    </van-image>
    <div class="album_title">
      <div class="album_title_box">
        <div class="albumName">相册详情</div>
        <span>{{albumDetails.description}}</span>
      </div>
      <div class="album_tips" :class="deleteShow?'delete_show' :''">
        <div>
          <i class="iconfont icon-duigou"></i>
        </div>
        <span>已成功删除{{delNumber}}个影像</span>
      </div>
    </div>
    <div class="album_tips_zw" :class="deleteShow?'seat_show' :''"></div>
    <div class="album_list_box" v-if="albumDetails.userPhotoList && Object.keys(albumDetails.userPhotoList).length">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false" :offset="10">
        <div class="album_item" :style="{paddingBottom:isShowCheck?'70px':'10px'}">
          <div v-for="(value,key,index) in albumDetails.userPhotoList" :key="index">
            <!-- <div class="album_item_title">{{key}}</div> -->
            <div v-for="(photoElement,photoIndex) of value" :key="photoIndex">
              <div class="album_item_title">
                <div class="album_item_title_date">{{key}}</div>
                <div class="album_item_title_name">{{photoElement.showText}}</div>
              </div>
              <div class="album_item_content">
                <div class="item_img_box" v-for="(imgItem,imgIndex) of photoElement.photoList" :key="imgIndex" @click.stop="check(key,photoIndex,imgIndex,imgItem)">
                  <van-image class="item_img" width="111px" height="111px" fit="cover" radius="4" :src="imgItem.photo | imgFormat">
                    <template v-slot:error>
                      <img :src="require('../../assets/styles/themes/img/photoAlbum1-mobile.png')" alt="" class="err_img">
                    </template>
                  </van-image>
                  <van-checkbox class="item_check" :value="imgItem.checked" v-if="isShowCheck " @click.prevent.self="check(key,photoIndex,imgIndex,imgItem)"></van-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <DsfMobileUploadImg ref="upload" @value-change="headSuccess" :uploadFileSize="1073741824" requestUrl=":/file/upload/" :accept="isAndroid ? 'image/*' :  '.jpg,.jpeg,.png'">

    </DsfMobileUploadImg>
    <div class="add_album_item" v-if="!isShowCheck" @click="downloadClick">
      <i class="iconfont icon-add"></i>
    </div>
    <div class="btn_album_bottom" v-if="isShowCheck">
      <div class="btn_list" :class="[chooseArr.length>1 || !showEdit?'ash_btn':'']" @click="editValue" v-if="chooseArr.length">
        <i class="iconfont icon-bianji"></i>
        <span>编辑</span>
      </div>
      <div class="btn_list" :class="[!chooseArr.length?'ash_btn':'']" @click="download">
        <i class="iconfont icon-yunduanxiazai"></i>
        <span>下载</span>
      </div>
      <div class="btn_list" :class="[!chooseArr.length || !showDelete?'ash_btn':'']" @click="deletePhoto">
        <i class="iconfont icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
    <van-image-preview v-model="show" :images="preview" class-name="preview_box" :start-position="startPosition" @change="onChange" @close="onClose">
    </van-image-preview>
    <van-dialog v-model="editDialog" title="照片描述" show-cancel-button @confirm="sureDescribe">
      <van-field v-model="describeValue" rows="4" type="textarea" maxlength="200" placeholder="请输入照片描述" show-word-limit :autosize="{ maxHeight: 100, minHeight: 50 }" />
    </van-dialog>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasClassAlbumDetails",
  ctrlCaption: "移动班级相册详情",
  mixins: [$mixins.layout],
  design: {
    isMask: false,
  },
  data() {
    return {
      chooseArr: [],
      isShowCheck: false,
      albumId: "",
      albumDetails: {},
      pageNum: 1,
      pageSize: 3,
      delNumber: 0,
      preview: [],
      previewData: [],
      previewIndex: 0,
      show: false,
      deleteShow: false,
      loading: false,
      finished: false,
      totalNum: 0,
      startPosition: 0,
      editDialog: false,//编辑弹窗
      describeValue: "",
      describeId: null,
      isAndroid: dsf.client.android(),
      photoNum: 0,
      showDelete: true,
      showEdit: true,
      newImgArr:[]
    }
  },
  props: {
    showConfirm: {
      type: Boolean,
      default: false
    },
    confirmTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    onLoad() {
      var arr = Object.keys(this.albumDetails.userPhotoList);
      if (this.totalNum == arr.length) {
        this.finished = true;
        return
      } else {
        this.pageNum++;
        this.getDetail();
      }
    },
    chooseAlbumList() {
      this.isShowCheck = true;
      this.washData(false);
      this.chooseArr = [];
    },
    // 全选
    selectAll() {
      this.chooseArr = [];
      this.washData(true);
      let washList = JSON.parse(JSON.stringify(this.albumDetails.userPhotoList))
      // 洗数据 在里面添加字段checked
      for (const key in washList) {
        if (Object.hasOwnProperty.call(washList, key)) {
          const element = washList[key];
          element.map(dateItem => {
            dateItem.photoList.map(photoItem => {
              if (photoItem.delPermissions) {
                this.chooseArr.push(photoItem)
              }
            })
          })
        }
      }
      this.albumDetails.userPhotoList = JSON.parse(JSON.stringify(washList))
    },
    check(key, photoIndex, imgIndex, imgItem) {
      // 预览图片
      this.preview = []
      this.previewData = [];
      if (this.isShowCheck) {
        // if (!imgItem.delPermissions) return
        let photoList = this.albumDetails.userPhotoList[key][photoIndex].photoList
        let id = photoList[imgIndex].id;
        if (photoList[imgIndex].checked) {
          this.chooseArr.forEach((ite, ind) => {
            if (ite.id == id) {
              this.chooseArr.splice(ind, 1)
            }
          });
          photoList[imgIndex].checked = false;
        } else {
          this.chooseArr.push(photoList[imgIndex])
          photoList[imgIndex].checked = true;
          this.chooseArr.forEach(element => {
            if (!element.delPermissions) this.showDelete = false;
            if (!element.editPermissions) this.showEdit = false;
          })
        }
        this.chooseNum = this.chooseArr.length
      } else {
        let that = this;
        let otherList = this.albumDetails.userPhotoList;
        // 洗数据 在里面添加字段checked
        for (const key in otherList) {
          if (Object.hasOwnProperty.call(otherList, key)) {
            const element = otherList[key];
            element.map(dateItem => {
              dateItem.photoList.map(photoItem => {
                let imgSrc = JSON.parse(photoItem.photo).relativePath || JSON.parse(photoItem.photo)[0].relativePath;
                imgSrc = dsf.url.getWebPath(imgSrc);
                this.preview.push(imgSrc)
                this.previewData.push(photoItem)
              })
            })
          }
        }
        this.previewData.forEach((item, index) => {
          if (item.id == this.albumDetails.userPhotoList[key][photoIndex].photoList[imgIndex].id) {
            that.startPosition = index
          }
        });
        this.describeValue = this.albumDetails.userPhotoList[key][photoIndex].photoList[imgIndex].description;
        this.show = true;
        if (!$('.preview_box').find('.download').length) {
          this.$nextTick(() => {
            if (this.describeValue != null) {
              $('<div class="img-describe">' + this.describeValue + '</div>').appendTo($('body'));
            }
            $('<div class="img-download">下载 </div>').appendTo($('body')).on('click', (params) => {
              let photo = JSON.parse(this.previewData[this.previewIndex].photo)
              this.downloadFile(photo)
            })
          })
        }
      }
    },
    // 预览图片
    onChange(index) {
      this.previewIndex = index;
      let otherList = this.albumDetails.userPhotoList;
      let id = this.previewData[index].id
      for (const key in otherList) {
        if (Object.hasOwnProperty.call(otherList, key)) {
          const element = otherList[key];
          element.map(dateItem => {
            dateItem.photoList.map(photoItem => {
              if (photoItem.id == id) {
                $('.img-describe').text(photoItem.description)
              }
            })
          })
        }
      }
    },
    onClose() {
      $(".img-download").remove();
      $(".img-describe").remove();
    },
    // 编辑
    editValue() {
      if (!this.showEdit) return
      let { chooseArr } = this;
      if (chooseArr.length == 1) {
        this.editDialog = true;
        this.describeValue = chooseArr[0].description;
        this.describeId = chooseArr[0].id;
      }
    },
    sureDescribe() {
      let loading = dsf.layer.loading();
      let { describeValue, describeId } = this
      let data = {
        albumPhotoId: describeId,
        desc: describeValue
      }
      this.$http.post('/mobile/teas/album/updateAlbumPhotoDesc', data).done((res) => {
        if (res.success && res.state == 20000) {
          this.pageNum = 1;
          this.albumDetails = [];
          this.getDetail();
          this.editDialog = false;
          this.chooseArr = [];
          dsf.layer.message(res.message || "编辑描述成功");
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    download() {
      this.photoNum = 0;
      this.downloadValue()
    },
    // 下载
    downloadValue() {
      if (this.chooseArr.length && this.chooseArr[this.photoNum]) {
        console.log(this.photoNum);
        this.downloadFile(JSON.parse(this.chooseArr[this.photoNum].photo));
      }
    },
    // 下载接口调用
    downloadFile(photo) {
      return new Promise((resolve, rejest) => {
        var id=photo.id || photo[0].id;
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android DreamsSoft") > -1 || u.indexOf("Android DreamSoft") > -1; //android终端
        var isiOS = u.indexOf("iOS DreamSoft") > -1; //ios终端
        var url = dsf.url.getWebPath("file/download");
        var origin = window.location.origin;
        if (isAndroid) {
          //android： 保存图片到相册
          // "?files=" + photo.id + "&zipName=" + id;
          $iaction.downloadPhoto({
            "url": origin + url + '?files=' + id + "&zipName=" + photo.originalFileName
          }, function () {
            resolve(e)
            setTimeout(() => {
              this.photoNum++;
              this.downloadValue()
            }, 500);
          }, function (e) {
            alert(e);
          });

        } else if (isiOS) {
          // iOS：保存图片到相册
          $MFile.download({
            remoteFileAddr: origin + url + '?files=' +id + "&zipName=" + photo.originalFileName,
            target: "/" + photo.originalFileName,
            type: "2",
          },
            function (resp) {

              console.log(resp);
              resolve(resp)
              alert('文件下载成功');
              setTimeout(() => {
                this.photoNum++;
                this.downloadValue()
              }, 500);
            }, function (error) {
              alert('文件下载失败');
            });

        } else {
          $(
            '<form action="' +
            url +
            '" method="get">' + // action请求路径及推送方法
            '<input type="text" name="files" value="' +
           id +
            '"/>' + // id^fileName
            + // 压缩包名称
            "</form>"
          )
            .appendTo("body")
            .submit()
            .remove();
          setTimeout(() => {
            resolve();
            this.photoNum++;
            this.downloadValue()
          }, 500);
        }

      })
    },
    itemClick() {
      this.checked = !this.checked
    },
    // 获取当前相册的详细内容
    getDetail() {
      let loading = dsf.layer.loading();
      let data = {
        albumId: this.albumId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$http.get('/mobile/teas/album/getAlbumContent', data).done((res) => {
        if (res.success && res.state == 20000) {
          this.totalNum = res.data.timeTotal;
          if (this.albumDetails.userPhotoList) {
            var arr = Object.keys(this.albumDetails.userPhotoList);
            if (this.totalNum != arr.length) {
              this.albumDetails.userPhotoList = { ...this.albumDetails.userPhotoList, ...res.data.userPhotoList }
              // 加载状态结束
            } else {
              this.finished = true;
            }
          } else {
            this.albumDetails = res.data;
          }
          this.loading = false;
          this.washData(false)
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    washData(val) {
      let washList = JSON.parse(JSON.stringify(this.albumDetails.userPhotoList))
      // 洗数据 在里面添加字段checked
      for (const key in washList) {
        if (Object.hasOwnProperty.call(washList, key)) {
          const element = washList[key];
          element.map(dateItem => {
            dateItem.photoList.map(photoItem => {
              photoItem.checked = val;
            })
          })
        }
      }
      this.albumDetails.userPhotoList = JSON.parse(JSON.stringify(washList))
    },
    goBack() {
      this.$router.go(-1);
    },
    deletePhoto() {
      if (!this.showEdit) return
      if (this.showConfirm) {
        let content = this.confirmTitle || '是否删除？'
        dsf.layer
          .confirm(content)
          .then(() => {
            this.deleteValue()
          })
          .catch(() => { });
      } else {
        this.deleteValue()
      }
    },
    // 删除
    deleteValue() {
      let that = this;
      let ids = []
      // 没有选择不执行删除接口
      if (!this.chooseArr.length) return
      this.chooseArr.map(ite => {
        ids.push(ite.id)
      })
      let data = {
        albumPhotoIds: JSON.stringify(ids)
      }
      this.$http.post('/teas/album/delAlbumPhotos', data).done((res) => {
        if (res.success && res.state == 20000) {
          this.delNumber = this.chooseArr.length;
          this.chooseArr = [];
          this.chooseNum = 0;
          this.pageNum = 1;
          this.albumDetails = {};
          this.getDetail();
          this.deleteShow = true;
          setTimeout(() => {
            that.deleteShow = false
          }, 1000)
          this.isShowCheck = false;
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {

        });
    },
    // 上传
    // 成功回调
    headSuccess(val) {
      let imgString = JSON.parse(val.args)
      imgString.map(res => {
        if (res.content) {
          return
        } else {
          if (res.suffix == 'jpg' || res.suffix == 'png' || res.suffix == 'gif' || res.suffix == 'jpeg') {
            this.newImgArr.push(res)
            // return res
          } else {
            return
          }
        }
      })
      if(this.newImgArr.length!==imgString.length) return
      let loading = dsf.layer.loading();
      let data = {
        albumId: this.albumId,
        photoContentStr: JSON.stringify(this.newImgArr)
      }
      this.$http.post('/mobile/teas/album/addAlbumPhotos', data).done((res) => {
        if (res.success && res.state == 20000) {
          dsf.layer.message(res.data || "上传成功");
          this.$refs['upload'].fileListCopy = []
          this.pageNum = 1;
          this.albumDetails = {};
          this.getDetail();
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
          this.newImgArr=[];
          dsf.layer.closeLoading(loading);
        });
    },
    downloadClick() {
      $('.van-uploader__input').click()
    }
  },
  destroyed() {
    $(".img-download").remove();
    $(".img-describe").remove();
  },
  created() {
    this.albumId = this.queryString.id || '';
    this.pageNum = 1;
    this.albumDetails = {};
    if (!this.isDesign) {
      this.getDetail()
    }
  }
})
</script>

<style>
</style>